import _ from 'lodash';
import React from 'react';
import { Helpers } from 'shared-components/helpers/helpers';
import PropTypes from 'prop-types';

export class List extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      value: null
    };

    this.handleClick = this.handleClick.bind(this);
    this.appendList = this.appendList.bind(this);
    this.renderDropdownListContainer = this.renderDropdownListContainer.bind(this);
  }

  handleClick (e) {
    const isMobile = Helpers.isMobile();
    let dataValue;

    if (isMobile) {
      dataValue = e.currentTarget.selectedOptions[0].getAttribute('data-value');
    } else {
      dataValue = e.currentTarget.getAttribute('data-value');
    }

    this.props.listClick(dataValue, this.props.listToggle);
  }

  appendList (isMobile) {
    const { listPreferred, listData, selectedValue } = this.props;
    if (listData && listPreferred) {
      const finalList = listPreferred.concat(listData);
      const list = _.map(finalList, (data, index) => {
        const highlight = (selectedValue === data) ? 'highlight' : '';
        if (isMobile) {
          const eleVal = (_.isString(data)) ? data : JSON.stringify(data);
          return (
            <option
              key={`${this.props.listKey}_${index}`}
              value={eleVal}
              data-value={JSON.stringify(data)}
            >
              {this.props.listContent(data, true)}
            </option>);
        }
        return (
          <li
            key={`${this.props.listKey}_${index}`}
            className={`${this.props.listClassName} ${highlight}`}
            data-value={JSON.stringify(data)}
            onClick={this.handleClick}
          >
            {this.props.listContent(data)}
          </li>
        );
      });

      if (this.props.listPreferred && !isMobile && 0 < this.props.listPreferred.length) {
        // Added dashed line between preffered countries and the rest
        const dashedLi = (<li key={`${this.props.listKey}_divider`} className="divider" />);
        list.splice(this.props.listPreferred.length, 0, dashedLi);
      }
      return list;
    }

    return null;
  }

  renderDropdownListContainer () {
    const isMobile = Helpers.isMobile();
    if (isMobile) {
      return (
        <select
          onChange={this.handleClick}
          data-value={this.state.value}
          value={this.props.selectedValue}
        >
          {this.appendList(isMobile)}
        </select>
      );
    }

    if (this.props.showDropdown) {
      return (
        <ul className={`dropdown-list ${this.props.ulClassName}`}
          aria-labelledby={null}
        >
          {this.appendList()}
        </ul>
      );
    }

    return null;
  }

  render () {
    return this.renderDropdownListContainer();
  }
}

List.propTypes = {
  listClick: PropTypes.func,
  listToggle: PropTypes.func,
  listPreferred: PropTypes.array,
  listData: PropTypes.array,
  listContent: PropTypes.func,
  listKey: PropTypes.string,
  listClassName: PropTypes.string,
  ulClassName: PropTypes.string,
  showDropdown: PropTypes.bool,
  selectedValue: PropTypes.string
};

List.defaultProps = {
  ulClassName: 'col-md-12'
};
